if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/custom-banner', {
        // built-in attributes
        title: 'Banner',
        description: 'Custom Banner',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            backgroundImage: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                backgroundImage,
                title,
            } = attributes;

            // custom functions

            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                    </PanelBody>
                    <PanelBody title={ 'Popup Content' }>
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,

                <section>
                    <div class="school-camp">
                        <div class="banner lozad overlay-warning" style={{ backgroundImage: `url(${backgroundImage})` }}>
                            <div class="position-absolute top-40 start-0 end-0 bottom-0">
                                <div class="container">
                                    <div class="d-flex justify-content-center">
                                        <div class="text-uppercase px-2 py-3 bg-primary">
                                            <h1 class="text-white mb-0 display-4 fw-normal">
                                            <RichText 
                                                key="editable" 
                                                tagName="h2" 
                                                class="title"
                                                placeholder="Title" 
                                                value={ title }
                                                onChange={ onTitleChange }
                                                style={ { color: '#fff' } } 
                                            />
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ]
            );
        },

        save({ attributes }) {

            const {
                backgroundImage,
                title,
            } = attributes;

            return (
                <section>
                    <div class="school-camp">
                        <div class="banner lozad overlay-warning" data-background-image={ backgroundImage }>
                            <div class="position-absolute top-40 start-0 end-0 bottom-0">
                                <div class="container">
                                    <div class="d-flex justify-content-center">
                                        <div class="text-uppercase px-2 py-3 bg-primary">
                                            <h1 class="text-white mb-0 display-4 fw-normal">
                                            <RawHTML>
                                                    { title }
                                            </RawHTML>
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        },
    });
}